import React from 'react';
import { Link } from 'react-router-dom';
import Logo from '../components/Logo';

const STOCK_TERMS = [
  ['1. Acceptance of Terms', 'By accessing or using any NexFlow Plumbing service or platform, you agree to be bound by these Terms of Service. If you do not agree, do not use the service.'],
  ['2. Services', 'NexFlow Inc. provides plumbing and related home services scheduled via this platform. Pricing, scope, and warranty information for each job is documented on the invoice or estimate provided to you.'],
  ['3. Account & Security', 'You are responsible for maintaining the confidentiality of your account credentials and for all activity that occurs under your account. Email verification is required to activate certain account types.'],
  ['4. Payments', 'Invoices are due according to the terms shown on each invoice. NexFlow accepts credit/debit cards via Stripe, ACH, check, and cash. Refunds are handled per the warranty terms on the job.'],
  ['5. SMS — Separate Consent', 'SMS text messaging is governed by a separate, standalone consent collected at /sms-consent. Acceptance of these Terms does NOT grant SMS consent. You can use NexFlow services without opting in to SMS, and SMS consent is not a condition of purchase. To opt in or out, visit /sms-consent or reply STOP to any text we send.'],
  ['6. Limitation of Liability', 'To the maximum extent permitted by law, NexFlow Inc. is not liable for indirect, incidental, special, consequential, or punitive damages arising from your use of the service.'],
  ['7. Changes', 'We may update these Terms from time to time. Material changes will be highlighted on this page or communicated by email.'],
  ['8. Contact', 'Questions about these Terms? Email support@nexflowplumbing.com.'],
];

const Terms = () => (
  <div className="min-h-screen bg-[#0A0A0A] text-white">
    <div className="border-b border-[#262626]">
      <div className="max-w-3xl mx-auto px-5 py-5 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3"><Logo size="sm" /><span className="font-['Outfit'] font-semibold">NEXFLOW PLUMBING</span></Link>
        <Link to="/" className="text-[#A3A3A3] text-sm hover:text-white">Home</Link>
      </div>
    </div>
    <div className="max-w-3xl mx-auto px-5 py-10 space-y-6">
      <div>
        <p className="text-[#D4AF37] text-xs font-bold tracking-[0.3em] mb-2">LEGAL</p>
        <h1 className="font-['Outfit'] text-3xl sm:text-4xl font-bold mb-2">Terms of Service</h1>
        <p className="text-[#525252] text-sm">Last updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</p>
      </div>
      <div className="bg-[#141414] border border-[#262626] rounded-md p-6 space-y-5">
        {STOCK_TERMS.map(([h, body]) => (
          <section key={h}>
            <h2 className="text-white font-medium mb-1">{h}</h2>
            <p className="text-[#A3A3A3] text-sm leading-relaxed">{body}</p>
          </section>
        ))}
      </div>
      <div className="border-t border-[#262626] pt-6 flex flex-wrap gap-x-6 gap-y-2 text-sm">
        <Link to="/terms" className="text-[#A3A3A3] hover:text-white">Terms of Service</Link>
        <Link to="/privacy" className="text-[#A3A3A3] hover:text-white">Privacy Policy</Link>
        <Link to="/sms-consent" className="text-[#A3A3A3] hover:text-white">SMS Consent</Link>
        <Link to="/sms-compliance" className="text-[#A3A3A3] hover:text-white">SMS Compliance</Link>
        <a href="mailto:support@nexflowplumbing.com" className="text-[#A3A3A3] hover:text-white">support@nexflowplumbing.com</a>
      </div>
    </div>
  </div>
);

export default Terms;
